import React from 'react';

function MainTitle(props) {
    return (
        <header role="banner">
            <h1>Tender</h1>
            <h2>The Non-Commital Shopping And Selling App</h2>
            <h3>Create. Sell. Buy.</h3>
      </header>
    )
}

export default MainTitle;